<template>
    <div>
        <!--<ActualizarEmpresas :tipoBd="'CONTA'" />-->

        <CRow>
            <CCol>
                <CCard class="tarjetaCV mt-2">
                    <CCardHeader>
                        <h4>Informe de Compras/Ventas</h4>
                    </CCardHeader>
                    <CCardBody>
                        <CRow><!--switch select ulti periodo-->
                            <CCol md="4">
                                <CSwitch
                                    width="150px"
                                    class="mx-1 align-middle mb-2 switchGesto"
                                    shape="pill"
                                    variant="outline"
                                    :checked="selectPeriodoActual"
                                    @update:checked="seleccionarPeriodoActual()"
                                /> Seleccionar último período
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="3">
                                <multiselect
                                    class="mb-2 multSelectGesto"
                                    :custom-label="customLabelEmp"
                                    v-model="empSelected"
                                    selectedLabel=""
                                    deselectLabel=""
                                    selectLabel=""
                                    placeholder="Seleccionar Empresa" 
                                    label="nombreEmpresa"
                                    :loading="isLoadingEmpresasInfo"
                                    track-by="codEmpresa" 
                                    :options="empresasInfo" 
                                    :multiple="false"
                                    @select="selectEmpresa">
                                </multiselect>
                            </CCol>
                            <CCol md="3">
                                <multiselect
                                    class="mb-2 multSelectGesto"
                                    v-model="compraVentaSelected"
                                    selectedLabel=""
                                    deselectLabel=""
                                    selectLabel=""
                                    placeholder="Seleccionar Compra/Venta" 
                                    label="nombre"
                                    track-by="id" 
                                    :options="comprasVentas" 
                                    :multiple="false"
                                    @select="seleccionarTipo">
                                </multiselect>
                            </CCol>
                             <CCol md="2">
                                <date-picker
                                    style="width: 100%"
                                    :disabled="!empSelected || periodosEmpresaSelected == null || periodosEmpresaSelected.length <= 0"
                                    :editable="false"
                                    :clearable="false"
                                    :format="'YYYY'"
                                    default-panel="year"
                                    type="year"
                                    class="mb-2"
                                    :lang="langPicker" 
                                    v-model="anioSelected"
                                    :confirm="false" 
                                    :confirm-text="'Aceptar'"
                                    :disabled-date="disabledMes"
                                    @change="seleccionarAnio">
                                </date-picker><!--:disabled-date="disabledMesLibRet"  :default-value="new Date(anioPickerSelectedLibRet)" -->
                            </CCol>
                            <CCol md="2">
                                <date-picker
                                    :default-value="anioObjSelected!==null? new Date(anioObjSelected.anio, 1, 1) : null"
                                    style="width: 100%"
                                    :disabled="!empSelected || periodosEmpresaSelected == null || periodosEmpresaSelected.length <= 0"
                                    :editable="false"
                                    :format="'MMMM'"
                                    default-panel="month"
                                    type="month"
                                    class="mb-2"
                                    :lang="langPicker" 
                                    v-model="mesSelected"
                                    :confirm="false" 
                                    :confirm-text="'Aceptar'"
                                    :disabled-date="disabledMes2"
                                    @change="seleccionarFechas2">
                                </date-picker>
                                <!--<date-picker
                                    style="width: 100%"
                                    :disabled="!empSelected"
                                    :editable="false"
                                    :clearable="false"
                                    :format="'MMMM'"
                                    default-panel="month"
                                    type="month"
                                    class="mb-2"
                                    :lang="langPicker" 
                                    v-model="fechaBusqueda"
                                    :confirm="false" 
                                    :confirm-text="'Aceptar'"
                                    :disabled-year="disabledAnio"
                                    :disabled-date="disabledMes"
                                    @change="seleccionarFechas">
                                </date-picker>-->
                                <!--:disabled-date="disabledMesLibRet"  :default-value="new Date(anioPickerSelectedLibRet)" -->
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol md="4">
                                <multiselect
                                    :disabled="!empSelected || periodosEmpresaSelected == null || periodosEmpresaSelected.length <= 0"
                                    class="mb-2"
                                    v-model="filtrosSelected" 
                                    :options="filtrosEmpresa" 
                                    select-label=""
                                    selectedLabel=""
                                    deselect-label=""
                                    selectGroupLabel=""
                                    deselectGroupLabel=""
                                    :multiple="true" 
                                    group-values="opcionesFiltro" 
                                    group-label="filtroNombre" 
                                    :group-select="true" 
                                    placeholder="Filtros Generales" 
                                    track-by="unico" 
                                    label="nombre"
                                    :show-labels="true"
                                    :loading="isLoadingFiltros"
                                    @input="actualizarFiltro"><!--@input="actualizarFiltroTrabajadores"-->
                                    
                                    <span slot="noResult">Oops! no se encuentran filtros con esa palabra</span>
                                    <template slot="tag" slot-scope="props">
                                        <span class="multiselect__tag">
                                            <span>({{props.option.padre}}) {{props.option.nombre}}</span> 
                                            <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="quitarTag(props.option, filtrosSelected)"></i>
                                        </span>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <span v-if="'$groupLabel' in props.option"><span class="text-capitalize font-weight-bold">{{props.option.$groupLabel}}</span> (Seleccionar/quitar todos)</span>
                                        <span v-else>{{props.option.nombre}}</span>
                                    </template>
                                </multiselect>
                            </CCol>
                            <CCol md="4">
                                <multiselect
                                    :disabled="!empSelected || periodosEmpresaSelected == null || periodosEmpresaSelected.length <= 0"
                                    class="multSelectGesto mb-2"
                                    v-model="rutSelected" 
                                    :options="ruts" 
                                    select-label=""
                                    selectedLabel=""
                                    deselect-label=""
                                    selectGroupLabel=""
                                    deselectGroupLabel=""
                                    :multiple="true" 
                                    placeholder="Mostrar por Rut" 
                                    track-by="rut"
                                    :custom-label="customLabelTrabajador"
                                    :loading="isLoadingTrabajadores"
                                    :show-labels="true"
                                    @input="actualizarFiltroRuts">
                                    <template slot="tag" slot-scope="props">
                                        <span class="multiselect__tag">
                                            <span>{{formatearRut(props.option.rut)}}</span> 
                                            <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="quitarTag(props.option, rutSelected)"></i>
                                        </span>
                                    </template>
                                </multiselect>
                            </CCol>
                            <CCol :md="(mostrarFiltrosContables)?12:2" :sm="(mostrarFiltrosContables)?12:3" :lg="(mostrarFiltrosContables)?12:2">
                                
                                <CCard v-show="empSelected != null || (periodosEmpresaSelected != null && periodosEmpresaSelected.length > 0)">
                                    
                                    <CCardHeader class="p-2" @click="mostrarFiltrosContables = !mostrarFiltrosContables" style="min-height: 40px;">
                                        <div class="card-header-actions float-left" >
                                            <CLink class="card-header-action btn-minimize">
                                                <CIcon v-show="mostrarFiltrosContables" :content="$options.freeSet.cilChevronTop" />
                                                <CIcon v-show="!mostrarFiltrosContables" :content="$options.freeSet.cilChevronBottom" />
                                            </CLink><span style="font-size: 0.67rem;">Filtros Contables</span>
                                        </div>
                                    </CCardHeader>
                                    <CCollapse :show="mostrarFiltrosContables" :duration="400">
                                        
                                        <CCardBody v-if="mostrarFiltrosContables" >
                                            <CRow>
                                                <CCol md="4" v-if="cuentasFiltro != null">
                                                    <multiselect
                                                        :disabled="!empSelected || periodosEmpresaSelected == null || periodosEmpresaSelected.length <= 0"
                                                        :v-show="cuentasFiltro.mostrarFiltro"
                                                        class="multSelectGesto mb-2"
                                                        v-model="cuentasSelected" 
                                                        :options="cuentasFiltro.filtros" 
                                                        select-label=""
                                                        selectedLabel=""
                                                        deselect-label=""
                                                        selectGroupLabel=""
                                                        deselectGroupLabel=""
                                                        :multiple="true" 
                                                        placeholder="Filtrar Cuentas" 
                                                        track-by="cuenta"
                                                        :custom-label="customLabelCuenta"
                                                        :loading="isLoadingCuentasFiltro"
                                                        :show-labels="true"
                                                        @input="actualizarFiltroCuentas">
                                                        <template slot="tag" slot-scope="props">
                                                            <span class="multiselect__tag">
                                                                <span>{{props.option.cuenta}}</span> 
                                                                <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="quitarTag(props.option, cuentasSelected)"></i>
                                                            </span>
                                                        </template>
                                                    </multiselect>
                                                </CCol>
                                                <CCol md="3" v-if="numDocs != null">
                                                    <multiselect
                                                        :disabled="!empSelected || periodosEmpresaSelected == null || periodosEmpresaSelected.length <= 0"
                                                        :v-show="numDocs.mostrarFiltro"
                                                        class="multSelectGesto mb-2"
                                                        v-model="numDocsSelected" 
                                                        :options="numDocs.filtros" 
                                                        select-label=""
                                                        selectedLabel=""
                                                        deselect-label=""
                                                        selectGroupLabel=""
                                                        deselectGroupLabel=""
                                                        :multiple="true" 
                                                        placeholder="Filtrar Documento" 
                                                        track-by="numDoc"
                                                        label="numDoc"
                                                        :loading="isLoadingNumDocFiltro"
                                                        :show-labels="true"
                                                        @input="actualizarFiltroNumDoc">
                                                        <template slot="tag" slot-scope="props">
                                                            <span class="multiselect__tag">
                                                                <span>{{props.option.numDoc}}</span> 
                                                                <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="quitarTag(props.option, numDocsSelected)"></i>
                                                            </span>
                                                        </template>
                                                    </multiselect>
                                                </CCol>
                                                <CCol md="3" v-if="filtrosCR != null">
                                                    <multiselect
                                                        :disabled="!empSelected || periodosEmpresaSelected == null || periodosEmpresaSelected.length <= 0"
                                                        v-show="filtrosCR.mostrarFiltro"
                                                        class="multSelectGesto mb-2"
                                                        v-model="filtrosCRSelected" 
                                                        :options="filtrosCR.filtros" 
                                                        select-label=""
                                                        selectedLabel=""
                                                        deselect-label=""
                                                        selectGroupLabel=""
                                                        deselectGroupLabel=""
                                                        :multiple="true" 
                                                        placeholder="Filtrar CR" 
                                                        track-by="codigo"
                                                        :custom-label="customLabelCR"
                                                        :loading="isLoadingCRFiltro"
                                                        :show-labels="true"
                                                        @input="actualizarFiltroCR">
                                                        <template slot="tag" slot-scope="props">
                                                            <span class="multiselect__tag">
                                                                <span>{{props.option.codigo}}</span> 
                                                                <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="quitarTagCR(props.option)"></i>
                                                            </span>
                                                        </template>
                                                    </multiselect>
                                                </CCol>
                                            </CRow>
                                        </CCardBody>
                                    </CCollapse>

                                </CCard>
                            </CCol>
                        </CRow>
                        
                        <!--<CRow>
                            
                        <CCol :md="(mostrarFiltrosContables2)?12:2">
                                
                                <CCard>
                                    
                                <CCardHeader class="p-2" @click="mostrarFiltrosContables2 = !mostrarFiltrosContables2">
                                    <div class="card-header-actions float-left" >
                                        <CLink class="card-header-action btn-minimize">
                                            <CIcon v-show="mostrarFiltrosContables2" :content="$options.freeSet.cilChevronTop" />
                                            <CIcon v-show="!mostrarFiltrosContables2" :content="$options.freeSet.cilChevronBottom" />
                                        </CLink><span style="font-size: 0.67rem;">Filtros Contables2</span>
                                    </div>
                                </CCardHeader>
                                </CCard>
                        </CCol>
                        </CRow>-->
                        
                        <!--<CRow>
                            <CCol md="12">
                                <vs-table v-model="selected">
                                    <template #thead>
                                    <vs-tr>
                                        <vs-th>
                                        Name
                                        </vs-th>
                                        <vs-th>
                                        Email
                                        </vs-th>
                                        <vs-th>
                                        Id
                                        </vs-th>
                                    </vs-tr>
                                    </template>
                                    <template #tbody>
                                    <vs-tr
                                        :key="i"
                                        v-for="(tr, i) in users"
                                        :data="tr"
                                        :is-selected="selected == tr"
                                    >
                                        <vs-td>
                                        {{ tr.name }}
                                        </vs-td>
                                        <vs-td>
                                        {{ tr.email }}
                                        </vs-td>
                                        <vs-td>
                                        {{ tr.id }}
                                        </vs-td>
                                    </vs-tr>
                                    </template>
                                </vs-table>
                            </CCol>
                        </CRow>-->
                        
                        <hr class="mt-0">

                        <CRow>
                            <CCol md="12">
                                    <CCardGroup class="mb-4 tarjetaTotales" v-if="totales != null" v-show="!isLoadingInfoCV">
                                        <CWidgetProgress v-show="totales.totalExento!=0" color="info">
                                            <div class="m-0 text-center font-weight-bold textosTotales">{{validarNegativos(totales.totalExento, true)}}</div>
                                        
                                            <div class="text-center text-muted">Exento Total</div>
                                        </CWidgetProgress>
                                        <CWidgetProgress v-show="totales.totalAfecto!=0">
                                            <div class="m-0 text-center font-weight-bold">{{validarNegativos(totales.totalAfecto, true)}}</div>
                                        
                                            <div class="text-center text-muted">Afecto Total</div>
                                        </CWidgetProgress>
                                    
                                        <CWidgetProgress v-show="totales.totalIva!=0">
                                            <div class="m-0 text-center font-weight-bold">{{validarNegativos(totales.totalIva, true)}}</div>
                                            <div class="text-center text-muted">Iva Total</div>
                                        </CWidgetProgress>
                                        <CWidgetProgress v-show="totales.totalOtrosImpuestos!=0">
                                            <div class="m-0 text-center font-weight-bold">{{validarNegativos(totales.totalOtrosImpuestos, true)}}</div>
                                            <div class="text-center text-muted">Otr. Imp. Total</div>
                                        </CWidgetProgress>
                                        <CWidgetProgress v-show="totales.totalMonto!=0">
                                            <div class="m-0 text-center font-weight-bold">{{validarNegativos(totales.totalMonto, true)}}</div>
                                            <div class="text-center text-muted">Total General</div>
                                        </CWidgetProgress>
                                        
                                    </CCardGroup>
                                    <!--<CRow class="align-items-end" v-show="!isLoadingInfoCV">
                                        <CCol></CCol>
                                        <CCol col="2" v-if="totales != null" v-show="totales.totalExento>0">
                                            <CWidgetProgress color="info" v-show="totales.totalExento>0">
                                                <div class="m-0 text-center font-weight-bold text-muted textosTotales">{{validarNegativos(totales.totalExento, true)}}</div>
                                            
                                                <div class="text-center text-muted">Exento Total</div>
                                            </CWidgetProgress>
                                        </CCol>
                                        <CCol col="2" v-if="totales != null">
                                            <CWidgetProgress>
                                                <div class="m-0 text-center text-muted">{{validarNegativos(totales.totalAfecto, true)}}</div>
                                            
                                                <div class="text-center font-weight-bold text-muted">Afecto Total</div>
                                            </CWidgetProgress>
                                        </CCol>
                                        
                                        <CCol col="2" v-if="totales != null" v-show="totales.totalIva>0">
                                            <CWidgetProgress>
                                                <div class="m-0 text-center text-muted ">{{validarNegativos(totales.totalIva, true)}}</div>
                                                <div class="text-center font-weight-bold text-muted">Iva Total</div>
                                            </CWidgetProgress>
                                        </CCol>
                                        <CCol col="2" v-if="totales != null" v-show="totales.totalOtrosImpuestos>0">
                                            <CWidgetProgress>
                                                <div class="m-0 text-center text-muted">{{validarNegativos(totales.totalOtrosImpuestos, true)}}</div>
                                                <div class="text-center font-weight-bold text-muted">Otr. Imp. Total</div>
                                            </CWidgetProgress>
                                        </CCol>
                                        <CCol col="2" v-if="totales != null" v-show="totales.totalMonto>0">
                                            <CWidgetProgress>
                                                <div class="m-0 text-center text-muted">{{validarNegativos(totales.totalMonto, true)}}</div>
                                                <div class="text-center font-weight-bold text-muted">Total General</div>
                                            </CWidgetProgress>
                                        </CCol>
                                    </CRow>-->
                                    <CRow v-if="isLoadingInfoCV">
                                        <CCol md="12">
                                            <center>
                                                <img src="/img/logo2.png" size="custom-size" :height="50" class="imgr mt-3 mb-3" /> Obteniendo Información...
                                            </center>
                                        </CCol>
                                    </CRow>
                                    
                                    <CRow v-else v-show="cvInfo.length > 0">
                                        <CCol md="12">
                                            <CRow v-for="cv in documentosFiltrados(cvInfo)" v-bind:key="cv.key">
                                                <CCol sm="12" md="12" lg="12">
                                                    <CCard accent-color="secondary" class="mt-1 mb-1" style="overflow-x:auto">
                                                        <CCardHeader>
                                                            <CLink class="card-header-action btn-minimize float-left" @click="cv.colapsed = !cv.colapsed">
                                                                <CIcon :name="`cil-chevron-${cv.colapsed ? 'bottom' : 'top'}`"/>
                                                            </CLink>
                                                            <CRow>
                                                            <CCol md="4">
                                                                {{cv.nombreTipoDoc}} <!--{{cv.tipoDocumento}} {{cv.mostrarTotalIva}}-->
                                                            </CCol>
                                                                <CCol md="8">
                                                                    <CRow class="align-items-end">
                                                                        <CCol></CCol>
                                                                        <!--<CCol col="2"><div class="ml-2 mr-2 text-muted float-right">Afecto Total {{validarNegativos(cv.totalAfecto, true)}}</div></CCol>
                                                                        <CCol col="2"><div class="ml-2 mr-2 text-muted float-right">Exento Total {{validarNegativos(cv.totalExento, true)}}</div></CCol>-->
                                                                        <CCol col="2" v-if="cv.tipoDocumento == 35 "><div class="ml-2 mr-2 text-muted float-right">Total Exento {{validarNegativos(cv.totalExento)}}</div></CCol>
                                                                        <CCol col="2" v-if="cv.tipoDocumento == 35 "><div class="ml-2 mr-2 text-muted float-right">Total Afecto {{validarNegativos(cv.totalAfecto)}}</div></CCol>
                                                                        <CCol col="2" v-show="cv.totalOtrosImpuestos > 0"><div  class="ml-2 mr-2 text-muted float-right">Otr. Imps {{validarNegativos(cv.totalOtrosImpuestos, true)}}</div></CCol>
                                                                        <CCol col="2" v-show="cv.mostrarTotalIva"><div class="ml-2 mr-2 text-muted float-right">Iva Total {{validarNegativos(cv.totalIva, true)}}</div></CCol>
                                                                        <CCol col="2"><div class="ml-1 mr-1 text-muted float-right">Monto Total {{validarNegativos(cv.totalGeneralMonto, true)}}</div></CCol>
                                                                    </CRow>
                                                                </CCol>
                                                            </CRow>
                                                            
                                                        </CCardHeader>
                                                        <CCollapse :show="cv.colapsed">
                                                            <div style="max-height:400px; overflow:hidden; overflow-x:scroll; overflow-y:scroll;" >
                                                            <CCardBody>
                                                                <!--<vs-table class="tableGesto">
                                                                    <template #thead>
                                                                        <vs-tr>
                                                                            <vs-th v-for="col in columnasCV" v-bind:key="col.scopedSlots.customRender"
                                                                                :style="{'text-align': col.align, 'width': col.width}">
                                                                                {{col.title}}
                                                                            </vs-th>
                                                                        </vs-tr>
                                                                    </template>
                                                                    <template #tbody v-if="compraVentaSelected != null" >
                                                                        <vs-tr
                                                                            v-show="compraVentaSelected.id === 1"                                                                        
                                                                            :key="doc.key"
                                                                            v-for="doc in cv.documentos"
                                                                            :data="doc"
                                                                            :is-selected="selected == doc"
                                                                        >
                                                                            <vs-td>
                                                                                {{ doc.cuenta }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ doc.fecha }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ doc.rut }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ doc.nombre }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ validarNegativos(doc.exento) }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ validarNegativos(doc.afecto) }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ validarNegativos(0) }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ validarNegativos(doc.iva) }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ validarNegativos(doc.otrosImpuestos) }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ validarNegativos(doc.monto) }}
                                                                            </vs-td>
                                                                        </vs-tr>
                                                                        <vs-tr
                                                                            v-show="compraVentaSelected.id === 2"                                                                        
                                                                            :key="doc.key"
                                                                            v-for="doc in cv.documentos"
                                                                            :data="doc"
                                                                        >
                                                                        <vs-td>
                                                                                {{ doc.cuenta }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ doc.correl }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ doc.fecha }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ doc.fechaVencimiento }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ doc.rut }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ doc.proveedor }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ validarNegativos(doc.exento) }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ validarNegativos(doc.afecto) }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ validarNegativos(doc.iva) }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ validarNegativos(doc.otrosImpuestos) }}
                                                                            </vs-td>
                                                                            <vs-td>
                                                                                {{ validarNegativos(doc.monto) }}
                                                                            </vs-td>
                                                                        </vs-tr>
                                                                    </template>
                                                                    
                                                                </vs-table>-->
                                                                <table class="tableGesto mt-2">
                                                                    <thead>
                                                                        <th v-for="col in columnasCVFiltradas(cv)" 
                                                                            v-bind:key="col.scopedSlots.customRender" 
                                                                            :style="{'text-align': col.align, 'width': col.width}">
                                                                            <!--@click="sortBy(cv, col.scopedSlots.customRender)">-->
                                                                            {{col.title}}
                                                                            <!--<i v-if="sortKey === col.scopedSlots.customRender" 
                                                                            :class="{ 'fa-caret-up': cv.documentos[col.scopedSlots.customRender] === 1, 'fa-caret-down': cv.documentos[col.scopedSlots.customRender] === -1 }" 
                                                                            class="fa"></i>-->
            
                                                                            <!--<a href="#" class="sort" data-sort="col.scopedSlots.customRender">
                                                                                
                                                                            </a>-->
                                                                        </th>
                                                                    </thead>
                                                                    <tbody v-if="compraVentaSelected != null" v-show="compraVentaSelected.id === 1">
                                                                       
                                                                        <tr v-for="doc in cv.documentos" v-bind:key="doc.numero">
                                                                            <td style="text-align: right;">{{doc.cuenta}}</td>
                                                                            <td style="text-align: left;">{{doc.fecha}}</td>
                                                                            <td style="text-align: left;">{{doc.rut}}</td>
                                                                            <td style="text-align: left;">{{doc.nombre}}</td>
                                                                            <td style="text-align: right;">{{validarNegativos(doc.exento) }}</td>
                                                                            <td style="text-align: right;">{{validarNegativos(doc.afecto) }}</td>
                                                                            <td style="text-align: right;">{{validarNegativos(0)}}</td>
                                                                            <td style="text-align: right;">{{validarNegativos(doc.iva)}}</td>
                                                                            <td style="text-align: right;">{{validarNegativos(doc.otrosImpuestos)}}</td>
                                                                            <td style="text-align: right;">{{validarNegativos(doc.monto)}}</td>
                                                                            <td style="text-align: center">
                                                                                <CIcon v-show="doc.nula" name="cil-x-circle"/>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <tbody  v-if="compraVentaSelected != null" v-show="compraVentaSelected.id === 2">
                                                                        <tr v-for="doc in cv.documentos" v-bind:key="doc.numero">
                                                                            <td style="text-align: right;">{{doc.cuenta}}</td>
                                                                            <td style="text-align: right;">{{doc.correl}}</td>
                                                                            <td style="text-align: left;">{{doc.fecha}}</td>
                                                                            <td style="text-align: left;">{{doc.fechaVencimiento}}</td>
                                                                            <td style="text-align: left;">{{doc.rut}}</td>
                                                                            <td style="text-align: left;">{{doc.proveedor}}</td>
                                                                            <td v-if="!hideExento" style="text-align: right;">{{validarNegativos(doc.exento) }}</td>
                                                                            <td v-if="!hideAfectoIva" style="text-align: right;">{{validarNegativos(doc.afecto) }}</td>
                                                                            <td v-if="!hideAfectoIva" style="text-align: right;">{{validarNegativos(doc.iva) }}</td>
                                                                            <td style="text-align: right;">{{validarNegativos(doc.otrosImpuestos)}}</td>
                                                                            <td style="text-align: right;">{{validarNegativos(doc.monto)}}</td>
                                                                            <td style="text-align: center">
                                                                                <CIcon v-show="doc.nula" name="cil-x-circle"/>
                                                                            </td>
                                                                        </tr>
                                                                        
                                                                    </tbody>
                                                                    <tfoot v-if="compraVentaSelected != null" v-show="compraVentaSelected.id === 1">
                                                                        <tr>
                                                                            <td colspan="4">Total</td>
                                                                            <td style="text-align:right;">{{validarNegativos(cv.totalExento)}}</td>
                                                                            <td style="text-align:right;">{{validarNegativos(cv.totalAfecto)}}</td>
                                                                            <td style="text-align: right;">{{validarNegativos(0)}}</td>
                                                                            <td style="text-align:right;">{{validarNegativos(cv.totalIva)}}</td>
                                                                            <td style="text-align:right;">{{validarNegativos(cv.totalOtrosImpuestos)}}</td>
                                                                            <td style="text-align:right;">{{validarNegativos(cv.totalGeneralMonto)}}</td> 
                                                                        </tr>
                                                                    </tfoot>
                                                                    <tfoot v-if="compraVentaSelected != null" v-show="compraVentaSelected.id === 2">
                                                                        <tr>
                                                                            <td colspan="6">Total</td>
                                                                            <td v-if="!hideExento" style="text-align:right;">{{validarNegativos(cv.totalExento)}}</td>
                                                                            <td v-if="!hideAfectoIva" style="text-align:right;">{{validarNegativos(cv.totalAfecto)}}</td>
                                                                            <td v-if="!hideAfectoIva" style="text-align:right;">{{validarNegativos(cv.totalIva)}}</td>
                                                                            <td style="text-align:right;">{{validarNegativos(cv.totalOtrosImpuestos)}}</td>
                                                                            <td style="text-align:right;">{{validarNegativos(cv.totalGeneralMonto)}}</td> 
                                                                        </tr>
                                                                    </tfoot>
                                                                </table>
                                                            </CCardBody>
                                                            </div>
                                                        </CCollapse>

                                                    </CCard>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                    
                            </CCol>
                        </CRow>
                        
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        
        
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    import Vue from 'vue'
    import cons from '@/const'
    import apiUrls from '@/views/utils/apiUrls'
    import axios from "axios"

    import ActualizarEmpresas from "@/views/utils/ActualizarEmpresas";

    import Multiselect from 'vue-multiselect'

    import VueModal from '@kouts/vue-modal';
    import '@kouts/vue-modal/dist/vue-modal.css';
    
    import { freeSet } from '@coreui/icons'

    import moment, { months } from 'moment'
    import { format, formatDistance, formatRelative, subDays, setYear, setMonth } from 'date-fns'
    import es from 'date-fns/locale/es'
    window.locale = 'es'

    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    export default {
        name: 'CompraVenta',
        freeSet,
        components: {
            Multiselect,
            'Modal': VueModal,
            ActualizarEmpresas,
            DatePicker       
        },
        data () {
            return {
                
                selected: null,
                urlBase: cons.port+"://" + cons.ipServer,
                
                tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                tipoUserAdmin: JSON.parse(this.$cookie.get('userLogginToken')).tipoUsuario,
                idCliente: JSON.parse(this.$cookie.get('userLogginToken')).idCliente,
                
                /*Globales*/
                comprasVentas: [{id: 2, nombre: 'Compras'}, {id: 1, nombre: 'Ventas'}],
                configNumeros: {
                    symbol: '',
                    thousandsSeparator: '.',
                    fractionCount: 2,
                    fractionSeparator: ',',
                    symbolPosition: 'back', 
                    symbolSpacing: false,
                    avoidEmptyDecimals: undefined,
                },
                
                langPicker: cons.langPicker,

                actTab: 0,

                /*Filtros*/
                filtrosCR: null,
                filtrosCRSelected: null,
                cuentasFiltro: null,
                cuentasSelected: null,
                numDocs: null,
                numDocsSelected: null,


                periodosEmpresaSelected: null,
                
                anioSelected: null,
                anioObjSelected: null,

                mesSelected: null,
                mesObjSelected: null,

                fechaBusqueda: null,
                usarGrilla: false,
                empresasInfo: [],
                compraVentaSelected: null,
                filtrosEmpresa: [],
                filtrosSelected: null,
                ruts: [],
                rutSelected: null,
                empSelected: null,
                isLoadingTrabajadores: false,
                isLoadingPeriodos: false,
                isLoadingFiltros: false,
                isLoadingEmpresasInfo: false,
                isLoadingInfoCV: false,
                
                isLoadingCuentasFiltro: false,
                isLoadingCRFiltro: false,
                isLoadingNumDocFiltro: false,
                
                totales: null,
                cvInfo: [],
                comprasInfo: [],


                columnasCV: [],
                    
                sortKey: '',
                sortOrders: {},
                tipoOrden: 'normal',

                mostrarFiltrosContables: false,
                mostrarFiltrosContables2:false,

                selectPeriodoActual: false,

                notificacionNulas: false,                hideExento: false,
                hideAfectoIva: false,
            }
        },
        created: function(){
            
        },
        beforeMount() {
            let cookieUsername = this.$cookie.get('userLogginToken')
            if(cookieUsername === null || cookieUsername === ""){
                this.$router.push("/pages/login");
            }
        },
        mounted(){
            this.obtenerSoloInfoEmpresas()
            
            //this.getCompraVenta()

        },
        methods: {
            columnasCVFiltradas(cv) {
                // Si el documento es "Factura Afecta Electrónico", ocultar columna "Exento"
                if (cv.tipoDocumento === '33') {
                    this.ocultarExento(cv)
                    return this.columnasCV.filter(columna => columna.title !== "Exento");
                }

                // Si el documento es "Factura Exenta o no Gravadas", se oculta la columna "Afecto" e "IVA"
                if (cv.tipoDocumento === '34') {
                    this.ocultarAfectoIva(cv)
                    return this.columnasCV.filter(columna => 
                        columna.title !== "Afecto" && 
                        columna.title !== "IVA"
                        );
                }
                return this.columnasCV;
            },
            ocultarExento: function(cv) {
                this.hideExento = true
            },
            ocultarAfectoIva: function (cv){
                this.hideAfectoIva = true
            },
            /* Opciones Iniciales */
            seleccionarPeriodoActual: function(){
                
                this.selectPeriodoActual = !this.selectPeriodoActual

                if(this.empSelected !== null && this.compraVentaSelected !== null){
                    this.validarUltimoPeriodo()
                } else{
                    
                    if(this.compraVentaSelected === null){
                        this.compraVentaSelected = this.comprasVentas[0]
                        this.seleccionarTipo()
                    }
                    if(this.empSelected === null){
                        this.empSelected = this.empresasInfo[0]
                        this.selectEmpresa()
                    }

                }

            },
            seleccionarTipo: function(compVent){
                this.validarSeleciones(false)
            },
            selectEmpresa: function(){
                this.getPeriodosEmpresa()
            },
            validarUltimoPeriodo: function(){
                if(this.selectPeriodoActual){
                    let anioSel = this.periodosEmpresaSelected[this.periodosEmpresaSelected.length - 1]
                    let mesSel = anioSel.meses[anioSel.meses.length - 1]
                    this.anioObjSelected = anioSel
                    this.anioSelected = new Date(anioSel.anio, 1, 1) 
                    this.mesSelected = new Date(anioSel.anio, mesSel.mesValor-1, 1)
                    this.selectPeriodoActual = false
                }
                this.validarSeleciones(true)
            },
            
            /* Fin Opciones Iniciales */
            
            

            
            sortBy: function(cv, colSort){
                if(this.tipoOrden == 'normal'){
                    cv["respaldoData"] = cv.documentos
                    this.tipoOrden = 'asc'
                }else if(this.tipoOrden == 'asc'){
                    this.tipoOrden = 'desc'
                }else if(this.tipoOrden == 'desc'){
                    this.tipoOrden = 'normal'
                }

                if(this.tipoOrden === 'normal'){
                    cv.documentos = cv["respaldoData"]
                    return
                }
                cv.documentos.sort((a, b) => {
                    if(this.tipoOrden == 'asc'){
                        return (a[colSort].localeCompare(b[colSort])) ? 1 : -1;
                    }else if(this.tipoOrden == 'desc'){
                        return (a[colSort].localeCompare(b[colSort])) ? 1 : -1;
                    }
                });
            },

            formatearRut: function(rut){
                var rutaFormatear = rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase();
                let len = rutaFormatear.length - 1;
                if (len > 3) {
                    let dv = rutaFormatear[len];
                    let beforeDv = rutaFormatear.substring(0, len).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                    rutaFormatear = beforeDv + '-' + dv;
                }
                return rutaFormatear;
            },
            quitarTagFiltro: function(tag){
                this.filtrosSelected.splice(this.filtrosSelected.indexOf(tag), 1)
                this.validarSeleciones(false)

            },
            quitarTag: function(tag, desde){
                desde.splice(desde.indexOf(tag), 1)
                this.validarSeleciones(false)
                                
            },
            quitarTagCuenta: function(tag, desde){
                desde.splice(desde.indexOf(tag), 1)
                this.validarSeleciones(false)
            },
            quitarTagCR: function(tag){
                this.filtrosCRSelected.splice(this.filtrosCRSelected.indexOf(tag), 1)
                this.validarSeleciones(false)
            },
            quitarTagNumDoc: function(tag){
                this.numDocsSelected.splice(this.numDocsSelected.indexOf(tag), 1)
                this.validarSeleciones(false)
            },
            actualizarFiltro: function(filtro){
                this.validarSeleciones(false)        
            },
            actualizarFiltroRuts: function(filtro){
                this.validarSeleciones(false)
            },
            actualizarFiltroCuentas: function(){
                this.validarSeleciones(false)
            },
            actualizarFiltroCR: function(){
                this.validarSeleciones(false)
            },
            actualizarFiltroNumDoc: function(){
                this.validarSeleciones(false)
            },
            customLabelTrabajador: function(trabajador){
                return `(${this.formatearRut(trabajador.rut)}) ${trabajador.nombre}`
            },
            disabledAnio: function(date, currentValue){
                let anioAct = format(date, "yyyy", {locale: es})
                let anioNoEncontrado = false
                this.periodosEmpresaSelected
                return anioNoEncontrado
            },
            disabledMes2: function(date, currentValue){
                let mesAct = format(date, "M", {locale: es})
                let anio = format(date, "yyyy", {locale: es})
                
                let mesNoEncontrado = true
                if(this.anioObjSelected !== null){
                    //anio = this.periodosEmpresaSelected.find(periodo => periodo.anio == anio)
                    if (anio === this.anioObjSelected.anio) {
                        mesNoEncontrado = this.anioObjSelected.meses.find(mes => mes.mesValor == parseInt(mesAct)) === undefined
                    }
                }

                return mesNoEncontrado
            },
            disabledMes: function(date, currentValue){
                
                let mesAct = format(date, "M", {locale: es})
                let anio = format(date, "yyyy", {locale: es})
                
                let mesNoEncontrado = true

                if(this.periodosEmpresaSelected !== null){
                    anio = this.periodosEmpresaSelected.find(periodo => periodo.anio == anio)
                    if (anio !== undefined) {
                        mesNoEncontrado = anio.meses.find(mes => mes.mesValor == parseInt(mesAct)) === undefined
                    }
                }
                

                return mesNoEncontrado
            },
            validarSeleciones: function(validarFechas){
                if(this.compraVentaSelected !== null && this.empSelected !== null && this.anioSelected !== null){
                    if(validarFechas){
                        let anio = format(this.anioSelected, "yyyy", {locale: es})
                        let mes = null
                        
                        if(this.mesSelected != null){
                            mes = format(this.mesSelected, "M", {locale: es})
                        }

                        if(this.disabledAnio(this.anioSelected)){
                            this.anioSelected = null
                            this.mostrarNotificaciones(2, 'El año seleccionado no se encuentra disponible para la empresa seleccionada')
                            return
                        }
 
                        let mesEncontrado = this.anioObjSelected.meses.find(ms => ms.mesValor == parseInt(mes))
                        
                        
                        if(mesEncontrado == null){
                            //this.mesSelected = null
                            if(this.mesSelected == null){
                                this.mesSelected = new Date(this.anioObjSelected.anio, this.anioObjSelected.meses[0].mesValor - 1, 1)
                            } else {
                                let ultimoMes = 0;
                                for (let i = 0; i < this.anioObjSelected.meses.length ;i++){
                                    if(ultimoMes < this.anioObjSelected.meses[i].mesValor){
                                        ultimoMes = this.anioObjSelected.meses[i].mesValor
                                    }
                                }
                                this.mesSelected = new Date(this.anioObjSelected.anio, ultimoMes - 1, 1)
                                this.mostrarNotificaciones(3,'No se han encontrado datos de este mes. Mostrando datos del mes más reciente de ese año')
                            }
                            //this.mostrarNotificaciones(2, 'El mes seleccionado no se encuentra disponible para la empresa seleccionada')
                            //return
                        } else {
                            this.mesSelected.setFullYear(this.anioObjSelected.anio)
                        }
                        
                    }
                    this.getFiltrosEmpresa()
                    this.getCompraVenta()
                }
                /*if(this.compraVentaSelected !== null && this.empSelected !== null && this.fechaBusqueda !== null){
                    if(validarFechas){
                        let mes = format(this.fechaBusqueda, "M", {locale: es})
                        let anio = format(this.fechaBusqueda, "yyyy", {locale: es})

                        if(this.disabledMes(this.fechaBusqueda)){
                            this.fechaBusqueda = null
                            this.mostrarNotificaciones(2, 'El periodo seleccionado no se encuentra disponible para la empresa seleccionada')
                            return
                        }
                    }
                    this.getFiltrosEmpresa()
                    this.getCompraVenta()
                }*/
            },
            seleccionarAnio: function(){
                this.anioObjSelected = this.periodosEmpresaSelected.find(periodo => periodo.anio == format(this.anioSelected, "yyyy", {locale: es}))
                this.validarSeleciones(true)
            },
            seleccionarFechas2: function(){
                this.validarSeleciones(true)
                /*if(this.empSelected !== null  && this.compraVentaSelected !== null){
                    this.getFiltrosEmpresa()
                    this.getCompraVenta()
                }*/
            },
            seleccionarFechas: function(){
                this.validarSeleciones(false)
                /*if(this.empSelected !== null  && this.compraVentaSelected !== null){
                    this.getFiltrosEmpresa()
                    this.getCompraVenta()
                }*/
            },
            
            
            customLabelCuenta: function(cuenta){
                return `(${cuenta.cuenta}) ${cuenta.nombreCuenta}`
            },
             customLabelCR: function(cr){
                return `(${cr.codigo}) ${cr.nombre}`
            },
            getFiltrosEmpresa: function(){
                this.isLoadingFiltros = true
                this.isLoadingTrabajadores = true
                this.isLoadingCuentasFiltro = true
                this.isLoadingCRFiltro = true
                this.isLoadingNumDocFiltro = true
                var url = this.urlBase + apiUrls.contabilidad.compraVenta.getFiltrosEmpresa
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": this.idCliente,
                            "idEmpresa": this.empSelected.idEmpresa,
                            "mes": this.mesSelected!==null?format(this.mesSelected, "M", {locale: es}):null,
                            "anio": this.anioSelected!==null?format(this.anioSelected, "yyyy", {locale: es}):null,
                            "compraVenta": this.compraVentaSelected.id,
                            "filtros": this.filtrosSelected,
                            "rutSeleccionados": this.rutSelected,
                            "cuentas": this.cuentasSelected,
                            "cr": this.filtrosCRSelected,
                            "numDoc": this.numDocsSelected,
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    //this.mostrarNotificaciones(1, result.data.mensajeGeneral)
                    this.isLoadingFiltros = false
                    this.isLoadingTrabajadores = false
                    this.isLoadingCuentasFiltro = false
                    this.isLoadingCRFiltro = false
                    this.isLoadingNumDocFiltro = false

                    this.filtrosEmpresa = result.data.filtros
                    this.ruts = result.data.filtrosRut
                     this.cuentasFiltro = result.data.cuentas
                    this.filtrosCR = result.data.crEmpresa
                    this.numDocs = result.data.numDoc

                }, error => {
                    this.isLoadingFiltros = false
                    this.isLoadingCuentasFiltro = false
                    this.isLoadingTrabajadores = false
                    this.isLoadingCRFiltro = false
                    this.isLoadingNumDocFiltro = false

                })
                .finally(() => {
                    this.isLoadingFiltros = false
                    this.isLoadingTrabajadores = false
                    this.isLoadingCuentasFiltro = false
                    this.isLoadingCRFiltro = false
                    this.isLoadingNumDocFiltro = false

                });
            },
            getPeriodosEmpresa: function(){
                this.isLoadingPeriodos = true
                var url = this.urlBase + apiUrls.contabilidad.compraVenta.getPeriodosEmpresa
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": this.idCliente,
                            "idEmpresa": this.empSelected.idEmpresa
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.isLoadingPeriodos = false
                    if(result.data.periodos.length <= 0){
                        this.mostrarNotificaciones(2, 'La empresa seleccionada no tiene periodos para mostrar')
                        
                        this.periodosEmpresaSelected = null
                        this.anioSelected = null
                        this.mesSelected = null

                        this.filtrosSelected = null
                        this.rutSelected = null
                        this.cuentasSelected = null
                        this.numDocsSelected = null
                        this.filtrosCRSelected = null
                
                    } else{
                        this.periodosEmpresaSelected = result.data.periodos
                        this.validarUltimoPeriodo()

                    }
                }, error => {
                    this.isLoadingPeriodos = false
                    //let mensaje = `Problema al obtener empresas , ${error}`
                    //this.textoSinEmpresas = mensaje
                })
                .finally(() => {
                    this.isLoadingPeriodos = false
                });
            },
            getCompraVenta: function(){
                this.isLoadingInfoCV = true
                var url = this.urlBase + apiUrls.contabilidad.compraVenta.getCV
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": this.idCliente,
                            "idEmpresa": this.empSelected.idEmpresa,
                            "mes": this.mesSelected!==null?format(this.mesSelected, "M", {locale: es}):null,//format(this.fechaBusqueda, "M", {locale: es}),
                            "anio": this.anioSelected!==null?format(this.anioSelected, "yyyy", {locale: es}):null,//format(this.fechaBusqueda, "yyyy", {locale: es})
                            "compraVenta": this.compraVentaSelected.id,
                            "filtros": this.filtrosSelected,
                            "rutSeleccionados": this.rutSelected,
                            "cuentas": this.cuentasSelected,
                            "cr": this.filtrosCRSelected,
                            "numDoc": this.numDocsSelected,
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    //this.mostrarNotificaciones(1, result.data.mensajeGeneral)
                    if(this.compraVentaSelected.id === 1){
                        this.columnasCV = [{ title: 'Número', scopedSlots: { customRender: 'cuenta' }, width: '7%', align: 'right', ellipsis: true},
                            { title: 'Fecha', scopedSlots: { customRender: 'fecha' }, width: '12%', align: 'left', ellipsis: false},
                            { title: 'RUT', scopedSlots: { customRender: 'rut' }, width: '12%', align: 'left', ellipsis: false},
                            { title: 'Nombre', scopedSlots: { customRender: 'nombre' }, width: '16%', align: 'left', ellipsis: false},
                            { title: 'Exento', scopedSlots: { customRender: 'exento' }, width: '8%', align: 'right', ellipsis: false},
                            { title: 'Afecto', scopedSlots: { customRender: 'afecto' }, width: '7%', align: 'right', ellipsis: false},
                            { title: 'Créd 12,35%', scopedSlots: { customRender: 'cred12' }, width: '7%', align: 'right', ellipsis: false},
                            { title: 'IVA', scopedSlots: { customRender: 'iva' }, width: '7%', align: 'right', ellipsis: false},
                            { title: 'Otr. Imp.', scopedSlots: { customRender: 'otrosImpuestos' }, width: '7%', align: 'right', ellipsis: false},
                            { title: 'Monto', scopedSlots: { customRender: 'monto' }, width: '7%', align: 'right', ellipsis: false}
                        ]
                    }
                    else if(this.compraVentaSelected.id === 2){
                        this.columnasCV = [{ title: 'Número', scopedSlots: { customRender: 'cuenta' }, width: '7%', align: 'right', ellipsis: true},
                            { title: 'Correl', scopedSlots:{ customRender: 'correl' }, width: '5%', align: 'right', ellipsis: true},
                            { title: 'Fecha', scopedSlots: { customRender: 'fecha' }, width: '12%', align: 'left', ellipsis: false},
                            { title: 'Fecha Venc.', scopedSlots: { customRender: 'fechaVencimiento' }, width: '12%', align: 'left', ellipsis: false},
                            { title: 'RUT', scopedSlots: { customRender: 'rut' }, width: '12%', align: 'left', ellipsis: false},
                            { title: 'Proveedores', scopedSlots: { customRender: 'proveedor' }, width: '16%', align: 'left', ellipsis: false},
                            { title: 'Exento', scopedSlots: { customRender: 'exento' }, width: '8%', align: 'right', ellipsis: false},
                            { title: 'Afecto', scopedSlots: { customRender: 'afecto' }, width: '7%', align: 'right', ellipsis: false},
                            { title: 'IVA', scopedSlots: { customRender: 'iva' }, width: '7%', align: 'right', ellipsis: false},
                            { title: 'Otr. Imp.', scopedSlots: { customRender: 'otrosImpuestos' }, width: '7%', align: 'right', ellipsis: false},
                            { title: 'Monto', scopedSlots: { customRender: 'monto' }, width: '7%', align: 'right', ellipsis: false}
                        ]
                    }
                    this.cvInfo = result.data.cvInfo
                    this.totales = result.data.totales

                    if(this.filtrosSelected.length > 0){
                        for(var i = 0; i < this.filtrosSelected.length; i++){
                            if(this.filtrosSelected[i].padre == "Mostrar"){
                                if(this.filtrosSelected[i].codigo == "Nulas"){
                                    //{ title: 'Monto', scopedSlots: { customRender: 'mont' }, width: '7%', align: 'right', ellipsis: false}
                                    this.columnasCV.push({ title: 'Nulas', scopedSlots: { customRender: 'nulas' }, width: '5%', align: 'center', ellipsis: false})
                                }
                            }
                        }
                    }
                    if(this.compraVentaSelected.id == 2){
                        this.comprasInfo = result.data.cvInfo
                    }
                    this.isLoadingInfoCV = false
                }, error => {
                    this.isLoadingInfoCV = false
                    //let mensaje = `Problema al obtener empresas , ${error}`
                    //this.textoSinEmpresas = mensaje
                })
                .finally(() => {
                    this.isLoadingInfoCV = false
                });
            },

            /*Globales*/
            obtenerSoloInfoEmpresas: function(){
                this.isLoadingEmpresasInfo = true
                var url = this.urlBase + apiUrls.general.getEmpresasInfo+"/CONTA" //"/get_empresas_info/CONTA";
                
                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    
                    this.empresasInfo = result.data;

                }, error => {
                    this.isLoadingEmpresasInfo = false
                    //let mensaje = `Problema al obtener empresas , ${error}`
                    //this.textoSinEmpresas = mensaje
                })
                .finally(() => {
                    this.isLoadingEmpresasInfo = false
                });
            },
            customLabelEmp (empresa) {
                return `(${empresa.codEmpresa}) ${empresa.nombreEmpresa}`;
            },
            
            validarNegativos: function(valor, usarSigno=false){
                let tipoFiltro = usarSigno?'currency':'soloNumeros'
                
                if(parseInt(valor) > 0){
                    return Vue.filter(tipoFiltro)(valor)
                }
                else if(parseInt(valor) == 0){
                    return ''
                } else{
                    return `(${(Vue.filter(tipoFiltro)(valor * -1))})`
                }
            },

            documentosFiltrados(cvInfo) {

                let documentos = this.cvInfo.flatMap(item => item.documentos || [])
                
                let soloNulas =  Array.isArray(this.filtrosSelected) && this.filtrosSelected.some(filtro => filtro.codigo === "SoloNulas")


                if(soloNulas){
                    documentos = documentos.filter(doc => {
                        if(doc.nulas === true && doc.fecha){
                            let anio = parseInt(doc.fecha.split("-")[0], 10)
                            return !isNaN(anio) && anio < 2021
                        }
                        return false
                    })

                    if(documentos.length === 0 && !this.notificacionNulas){
                        this.mostrarNotificaciones(3, 'No se encuentran documentos solo nulas');
                        this.notificacionNulas = true
                    }

                } else {
                    return cvInfo
                }

                return documentos
                
            },

            
        }
        
    }
</script>

<style>
 .sort::after {
      content: "\25b2";
      display: inline-block;
      margin-left: 5px;
   }
   
   .sort.asc::after {
      content: "\25bc";
   }
.textosTotales{
    font-size: 0.9em;
}
@media (max-width: 300px) {
      .textosTotales {
         font-size: 0.5em;
      }
   }
.mx-input{
    height: 40px !important;
}
</style>